export const ICON_BASE_URL = 'https://cdn.jsdelivr.net/npm/@carbon/icons@11.41.0';
